// extracted by mini-css-extract-plugin
export default {"slide":"BasicSlide_slide__C1y80","active":"BasicSlide_active__GvBzI"};